import React, { Component } from "react";
import GroupedNumberCellRenderer from "./GroupedNumberCellRenderer";
import GroupedDropDownCellRenderer from "./GroupedDropDownCellRenderer";

export default class GroupedCellRenderer extends Component {
  decideRenderer() {
    if (this.props.columnTypeId === "5" || this.props.columnTypeId === "17")
      return <GroupedNumberCellRenderer {...this.props} />;
    else return <GroupedDropDownCellRenderer {...this.props} />;
  }

  render() {
    return <div>{this.decideRenderer()}</div>;
  }
}
